"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TwoMediaRightTopTextLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TwoMediaRightTopTextLayout = (param)=>{
    let { banner, debug, modulePosition, className } = param;
    const { modules, layout, id } = banner;
    const { getTestId } = (0, _testidGenerator.default)();
    if (!modules || modules.length < 1) {
        return (0, _utils.getModulesLengthError)({
            debug,
            layout,
            modulePosition
        });
    }
    const [leftImage, rightImageTitle, rightImage] = modules;
    var _rightImageTitle_content;
    const { title, titleColor } = (_rightImageTitle_content = rightImageTitle === null || rightImageTitle === void 0 ? void 0 : rightImageTitle.content) !== null && _rightImageTitle_content !== void 0 ? _rightImageTitle_content : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.TwoMediaRightTopText),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.LeftSide, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.ImageBox, {
                        id: id,
                        module: leftImage,
                        imageParams: _constants.LEFT_IMAGE_PARAMS.params,
                        sizes: _constants.LEFT_IMAGE_PARAMS.sizes,
                        height: _constants.LEFT_IMAGE_DESKTOP_HEIGHT,
                        width: _constants.LEFT_IMAGE_DESKTOP_WIDTH
                    }),
                    (leftImage === null || leftImage === void 0 ? void 0 : leftImage.link) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Button, {
                        link: leftImage.link
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.RightSide, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Title, {
                        maxLines: 4,
                        color: titleColor,
                        title: title !== null && title !== void 0 ? title : '',
                        titleVariant: "h5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.ImageBox, {
                        id: id,
                        module: rightImage,
                        imageParams: _constants.RIGHT_IMAGE_PARAMS.params,
                        sizes: _constants.RIGHT_IMAGE_PARAMS.sizes,
                        height: _constants.RIGHT_IMAGE_DESKTOP_HEIGHT,
                        width: _constants.RIGHT_IMAGE_DESKTOP_WIDTH
                    }),
                    (rightImage === null || rightImage === void 0 ? void 0 : rightImage.link) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.Button, {
                        link: rightImage.link
                    }) : null
                ]
            })
        ]
    });
};
exports.TwoMediaRightTopTextLayout = TwoMediaRightTopTextLayout;
